/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WriteOnlyExternalSystemAccess
 */
export interface WriteOnlyExternalSystemAccess {
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyExternalSystemAccess
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyExternalSystemAccess
     */
    accessType: WriteOnlyExternalSystemAccessAccessTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyExternalSystemAccess
     */
    externalSystemName: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyExternalSystemAccess
     */
    externalSystemVersion: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyExternalSystemAccess
     */
    fetchType?: WriteOnlyExternalSystemAccessFetchTypeEnum;
}

export function WriteOnlyExternalSystemAccessFromJSON(json: any): WriteOnlyExternalSystemAccess {
    return WriteOnlyExternalSystemAccessFromJSONTyped(json, false);
}

export function WriteOnlyExternalSystemAccessFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteOnlyExternalSystemAccess {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'accessType': json['access_type'],
        'externalSystemName': json['external_system_name'],
        'externalSystemVersion': json['external_system_version'],
        'fetchType': !exists(json, 'fetch_type') ? undefined : json['fetch_type'],
    };
}

export function WriteOnlyExternalSystemAccessToJSON(value?: WriteOnlyExternalSystemAccess | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'access_type': value.accessType,
        'external_system_name': value.externalSystemName,
        'external_system_version': value.externalSystemVersion,
        'fetch_type': value.fetchType,
    };
}

/**
* @export
* @enum {string}
*/
export enum WriteOnlyExternalSystemAccessAccessTypeEnum {
    BasicAuth = 'basic_auth',
    Oauth2 = 'oauth2',
    CertIp = 'cert_ip'
}
/**
* @export
* @enum {string}
*/
export enum WriteOnlyExternalSystemAccessFetchTypeEnum {
    PASSIVE = 'PASSIVE',
    ACTIVE = 'ACTIVE'
}


